import ApiService from '@/shared/services/api.service';

// A citizen's form must render even if the translations service is degraded,
// so a slow resolve degrades to the source language instead of blocking.
const RESOLVE_TIMEOUT_MS = 4000;

// The router guard awaits fetchPublicSettings on every navigation, so this is
// cached per namespace and language - a failure included.
const bundleCache = new Map();

export class TranslationsService {
    // Bounded namespaces only - the endpoint has no size cap.
    static bundle(ns, language) {
        const cacheKey = `${ns}:${language}`;
        if (bundleCache.has(cacheKey)) {
            return bundleCache.get(cacheKey);
        }

        // A 403 here must not raise the global session-expired dialog.
        const request = ApiService.get(`translations/bundle?ns=${encodeURIComponent(ns)}`, undefined, {
            baseURL: window.VUE_APP_API_URL,
            suppressExpiredTokenModal: true,
        })
            .then((response) => response?.data || {})
            .catch(() => ({}));

        const timeout = new Promise((resolve) => {
            setTimeout(() => resolve({}), RESOLVE_TIMEOUT_MS);
        });

        const bundle = Promise.race([request, timeout]);
        bundleCache.set(cacheKey, bundle);

        return bundle;
    }

    static resolve(ns, id) {
        const request = ApiService.post('/translations/resolve', { keys: [{ ns, id }] })
            .then((response) => response?.data?.[ns]?.[id] || {})
            .catch(() => ({}));

        const timeout = new Promise((resolve) => {
            setTimeout(() => resolve({}), RESOLVE_TIMEOUT_MS);
        });

        return Promise.race([request, timeout]);
    }
}
